module.exports = {
	"id": "TL",
	"name": "Timor-Leste",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.04056,
			"5": null,
			"6": 0.01014,
			"7": 0.00676,
			"8": null,
			"9": 0.01014,
			"10": 0.00338,
			"11": 0.02028,
			"12": 0.0169,
			"13": 0.00338,
			"14": null,
			"15": 0.01014,
			"16": 0.01014,
			"17": null,
			"18": null,
			"19": 0.01352,
			"20": 0.01352,
			"21": null,
			"22": null,
			"23": 0.01014,
			"24": 0.00338,
			"25": 0.00338,
			"26": 0.02704,
			"27": 0.02366,
			"28": 0.00676,
			"29": 0.00676,
			"30": 0.00338,
			"31": 0.0169,
			"32": 2.08884,
			"33": 0.0169,
			"34": 0.03718,
			"35": 0.00676,
			"36": 0.02704,
			"37": 0.00338,
			"38": 0.01352,
			"39": 0.00676,
			"40": 0.06084,
			"41": 0.00676,
			"42": 0.00676,
			"43": 0.98358,
			"44": 0.02028,
			"45": 0.06084,
			"46": 0.03718,
			"47": 0.06084,
			"48": 0.03718,
			"49": 0.2535,
			"50": 0.04056,
			"51": 0.17238,
			"52": 0.1352,
			"53": 7.17236,
			"54": 1.521,
			"55": 0.07098,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.04732,
			"4": 0.2197,
			"5": 0.08112,
			"6": 0.10478,
			"7": 0.08788,
			"8": 0.04732,
			"9": 0.03042,
			"10": 0.16224,
			"11": 0.1014,
			"12": 0.19604,
			"13": 0.13858,
			"14": 0.04732,
			"15": 0.05408,
			"16": 0.13858,
			"17": 0.0338,
			"18": 0.0676,
			"19": 0.04732,
			"20": 0.0676,
			"21": 0.06084,
			"22": 0.05408,
			"23": 0.01352,
			"24": 0.05408,
			"25": 0.0338,
			"26": 0.01014,
			"27": 0.03718,
			"28": 0.05746,
			"29": 0.17914,
			"30": 0.11154,
			"31": 0.05746,
			"32": 0.0507,
			"33": 0.02704,
			"34": 0.0338,
			"35": 0.169,
			"36": 0.07098,
			"37": 0.07098,
			"38": 0.0845,
			"39": 0.08788,
			"40": 0.25012,
			"41": 0.19604,
			"42": 0.0845,
			"43": 0.5239,
			"44": 0.25688,
			"45": 0.10816,
			"46": 0.1521,
			"47": 1.13568,
			"48": 1.08498,
			"49": 4.80636,
			"50": 0.9126,
			"51": 0.00338,
			"52": null,
			"3.5": 0.05408,
			"3.6": 0.14872
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": 0.00676,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.04056,
			"20": null,
			"21": 0.02028,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.01014,
			"29": null,
			"30": 0.06422,
			"31": null,
			"32": null,
			"33": 0.00338,
			"34": 0.03042,
			"35": 0.04056,
			"36": 0.02028,
			"37": 0.24336,
			"38": 0.01352,
			"39": 0.04732,
			"40": 0.52052,
			"41": 0.0169,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.01014,
			"11.1": null,
			"11.5": null,
			"11.6": 0.01352,
			"12.1": 0.05408
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.01014,
			"6": 0.03718,
			"7": 0.0338,
			"8": 0.14196,
			"9": 0.22308,
			"10": 0.28054,
			"3.1": null,
			"3.2": null,
			"5.1": 0.05746,
			"6.1": 0.02366,
			"7.1": 0.00676,
			"9.1": 0.338
		},
		"ios_saf": {
			"8": 0,
			"10": 2.14019660866,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0576758221274,
			"8.1-8.4": 0.10655363749,
			"9.0-9.2": 0.0508329279767,
			"9.3": 0.775528003747
		},
		"android": {
			"3": 0,
			"4": 0.100088857881,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0125111072351,
			"4.1": 0.361034808786,
			"4.2-4.3": 0.902587021964,
			"4.4": 2.0696945969,
			"4.4.3-4.4.4": 2.08756760724
		},
		"ie": {
			"6": null,
			"7": 0.0203310831234,
			"8": 0.670925743073,
			"9": 0.311743274559,
			"10": 0.254138539043,
			"11": 1.4333413602,
			"5.5": null
		},
		"op_mob": {
			"0": 1.45840167742,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0405111577062
		},
		"edge": {
			"12": 0.1521,
			"13": 0.20618,
			"14": 0.13858
		},
		"ie_mob": {
			"10": 0.198383549296,
			"11": 0.807704450704
		},
		"bb": {
			"7": 0.02151175,
			"10": null
		},
		"samsung": {
			"0": 3.130787
		},
		"and_uc": {
			"0": 7.836896
		},
		"op_mini": {
			"0": 19.6487921649
		},
		"and_chr": {
			"0": 25.56319
		},
		"and_ff": {
			"0": 0.039714
		}
	},
	"total": 98.66164275
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/TL.json
 ** module id = 661
 ** module chunks = 0
 **/